import React, { useContext } from 'react';
import Loader from 'react-native-three-dots-loader';
import { ThemeContext } from '..';

export interface DotsLoaderProps {
  activeBackground?: string;
  animationDuration?: number;
  animationScale?: number;
  background?: string;
  dotMargin?: number;
  size?: number;
}

export const DotsLoader = (props: DotsLoaderProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);

  return (
    <Loader
      {...props}
      activeBackground={props.activeBackground || theme.colors.primary.normal}
      background={props.background || theme.colors.primary.normal}
    />
  );
};
